import * as React from 'react';
import Grid from '@mui/material/Grid';
import Dialog from '@mui/material/Dialog';
import { LuFilterX } from "react-icons/lu";
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { dateComparator, dateFmtToStr, getDt, getDtfrmt, statusBar } from "../../utils";
import { useState, useEffect, useMemo } from "react";
import { AgGridReact } from "ag-grid-react";
import StyledTooltip from '../shared/toolTip/StyledTooltip';
import { LuRefreshCcw } from "react-icons/lu";
import { TbSettingsCancel } from "react-icons/tb";
import toastr from 'toastr';
import "toastr/build/toastr.min.css";
import DialogActions from '@mui/material/DialogActions';
import { useDispatch, useSelector } from 'react-redux';
import './customLoadingOverlay.scss';
import { IconButton, LinearProgress } from '@mui/material';
import { bulkTagConfigCancelStart, bulkTagConfigStatusStart, changeLoadingPhaseStatus, } from '../redux/project/projActions';
import ConfirmDialog from '../shared/confirmBox/confirmDialog';
import StatusChip from '../shared/StatusChip';



const CustomTooltip = (props) => {
  return (
    <div className="custom-tooltip" style={{  backgroundColor: '#f0f4ff', whiteSpace: 'normal', padding: '10px' }}>
      <span className="panel-text">{props.value}</span>
    </div>
  );
};

const BulkConfig = (props) => {

  const wsTabValue = useSelector((state) => state.ctrl.wsTabValue);
  const isInstrumentationTab = wsTabValue === "Instrumentation" ? true : false;
  const commercialTypes = useSelector((state) => state.ctrl.commercialTypes);
  const loadingPhase = useSelector((state) => state.project.loadingPhase)
  const [isBlkStatusOpen, setIsBlkStatusOpen] = useState(false);
  let bulkUpdatedTags = useSelector(state => state.project.bulkUpdatedTags) || [];
  const allTags = useSelector(state => state.project.tags) || [];
  let ctrl = useSelector(state => state.ctrl) || [];
  const [gridApi, setGridApi] = useState(null);
  const [blkTloader, setBlkTloaderLoader] = useState(false)
  const [isCnclCnfgEnable, setIsCnclCnfgEnable] = useState(false)
  const [openCnfrmDialog, setOpenCnfrmDialog] = React.useState(false);

  const dispatch = useDispatch();
  const onGridReady = (params) => {
    setGridApi(params.api);
  }

  const AlphaNumericComp = (valueA = '', valueB = '') => {

    const valueALower = valueA + "".toLowerCase();
    const valueBLower = valueB + "".toLowerCase();
    return valueALower.localeCompare(valueBLower, 'en', { numeric: true });
  }



  useEffect(() => {
    if ((loadingPhase?.action === "BULK_TAG_CONFIG_STS" || loadingPhase?.action === "BULK_TAG_CONFIG_CANCEL") && loadingPhase?.phase === "START") {
      setBlkTloaderLoader(true)
      gridApi?.showLoadingOverlay()
    }
    if ((loadingPhase?.action === "BULK_TAG_CONFIG_STS" || loadingPhase?.action === "BULK_TAG_CONFIG_CANCEL") && loadingPhase?.phase === "SUCCESS") {
      setBlkTloaderLoader(false)
      gridApi?.hideOverlay()
      if (loadingPhase?.action === "BULK_TAG_CONFIG_CANCEL") {
        toastr.success("Cancel Configuration requested Successfully!");
        gridApi?.deselectAll();
      }
      dispatch(changeLoadingPhaseStatus({ "action": "", "phase": "INIT" }))
    }
    if (loadingPhase?.phase === "ERROR") {
      setBlkTloaderLoader(false)
      gridApi?.hideOverlay()
      dispatch(changeLoadingPhaseStatus({ "action": "", "phase": "INIT" }))
      if (loadingPhase?.action === "BULK_TAG_CONFIG_CANCEL") {
        toastr.error(`Unable to Cancel Configuration${loadingPhase.message.ErrorMessage}`);
      }
    }
  }, [loadingPhase])
  // useEffect(()=>{
  //     if(bulkUpdatedTags?.length>0)
  //     {
  //     const data = bulkUpdatedTags?.map(((item)=>{
  //         return {...item,state:"PENDING"}
  //     }))
  //     console.log(data)
  //     setRowData(data)}
  // },[bulkUpdatedTags])

  useEffect(() => {
    dispatch(bulkTagConfigStatusStart({ "project_id": ctrl?.data.project_id, "package_id": ctrl?.pkg?.package_id, "revision": +ctrl?.pkg?.active_revision }))
  }, [])

  const isRowSelectableTagGrid = (params) => {
    //useCallback((params) => {
    //let editFlag = (+slctRev?.value === +ctrl.pkg.active_revision)
    let editFlag = false;
    if (params.data?.delivery_status == "INPROCESS") {
      editFlag = true
    }
    return editFlag
  }


  // const statusClass = (params) => {
  //   if (params.value === "FAILURE" || params.value === "CANCELED") {
  //     return 'red-cell';
  //   } else if (params.value === "INPROCESS") {
  //     return 'orange-cell';
  //   } else if (params.value === "SUCCESS") {
  //     return 'green-cell';
  //   } else {
  //     return 'blue-cell'
  //   }

  // }
  const setDateFrmt = (params) => getDt(params.data.request_date)

  const statusRenderer = (params) => {
    const status = params.value;
    const color = status === "SUCCESS" ? "green" : status === "FAILURE" ? "red" : status === "CANCELED" ? "orange" : "blue";
    const statusLabel = status === "SUCCESS" ? "SUCCESS" : status === "FAILURE" ? "FAILED" : status === "CANCELED" ? "CANCELED" : "IN PROCESS";

    return (
      <div style={{ height: "100%", display: "flex", alignItems: "center" }}>
        <StatusChip label={statusLabel} color={color} />
      </div>
    );
  };


  const bulkUpdatedTagsWithParentTagNumber = useMemo(() => {
    const tagIdToTagNumber = new Map();

    // console.log("=== Parent Tag Number Debug ===");
    // console.log("allTags count:", allTags.length);
    // console.log("bulkUpdatedTags count:", bulkUpdatedTags.length);

    allTags.forEach((tag) => {
      if (tag?.tag_id !== null && tag?.tag_id !== undefined) {
        tagIdToTagNumber.set(String(tag.tag_id), tag?.tag_number || "");
      }
    });

    // console.log("tagIdToTagNumber map size:", tagIdToTagNumber.size);

    return bulkUpdatedTags.map((tag) => {
      const parentId = tag?.parent_id;
      const hasParentId = parentId !== null && parentId !== undefined && parentId !== "";
      const parentTagNumber = hasParentId ? (tagIdToTagNumber.get(String(parentId)) || "") : "";

      // console.log(`Tag: ${tag.tag_number} | parent_id: ${parentId} | resolved parent_tag_number: "${parentTagNumber}"`);

      return {
        ...tag,
        parent_tag_number: parentTagNumber,
      };
    });
  }, [bulkUpdatedTags, allTags]);

  const colDefs = useMemo(() => [
    // {
    //   headerName: '',
    //   minWidth: 60,
    //   maxWidth: 70,
    //   valueFormatter: (params) => {
    //     return `${parseInt(params.node.id) + 1}`;
    //   },
    // },
    {
      headerName: "S.No.", field: 'sel', filter: true, headerCheckboxSelection: true, resizable: false, showDisabledCheckboxes: true, checkboxSelection: true, editable: false, valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    { headerName: 'Tag Number', field: "tag_number", filter: true, minWidth: 130, sortable: true, resizable: true, },
    // { headerName: 'Technology Type', field: "technology_name", filter: true, minWidth: 165, resizable: true, sortable: true },
    { headerName: 'Request ID', field: "batch_id", filter: true, minWidth: 120, sortable: true, resizable: true, comparator: AlphaNumericComp, sort: 'desc' },
    { headerName: 'Request Date', field: "request_date", filter: true, minWidth: 120, sortable: true, valueGetter: (row) => dateFmtToStr(row.data.request_date), resizable: true, },
    { headerName: 'Request By', field: "request_by", filter: true, minWidth: 150, resizable: true },
    // { headerName: 'Delivery Status', field: "delivery_status", filter: true, minWidth: 150, cellClass: statusClass, resizable: true, sortable: true, },
    { headerName: 'Delivery Status', field: "delivery_status", filter: true, minWidth: 150, resizable: true, sortable: true, cellRenderer: statusRenderer },
    { headerName: 'Oracle Quote', field: "quote_number", filter: true, minWidth: 100, resizable: true, },
    // { headerName: 'Project Name', field: "project_name", filter: true, minWidth: 120, resizable: true, },
    // { headerName: 'Package Name', field: "package_name", filter: true, minWidth: 120, resizable: true, },
    { headerName: 'Comments', field: "comments", filter: true, minWidth: 400, resizable: true, tooltipField: "comments", tooltipComponent: CustomTooltip },
    { headerName: 'Configuration Import Status', field: "configuration_import", filter: true, minWidth: 150, resizable: true },
    { headerName: 'Cloud Config Id', field: "cloud_config_id", filter: true, minWidth: 150, resizable: true },
    { headerName: 'Parent Tag Number', field: "parent_tag_number", filter: true, minWidth: 150, sortable: true, resizable: true, }

  ], []);

    const defaultColDef = useMemo(() => ({
    flex: 1,
    sortable: true,
    resizable: true,
    filter: true,
    editable: false,
    sortingOrder: ["asc", "desc", " "],
    filterParams: {
      buttons: ["apply", "cancel"],
      closeOnApply: true,
    },
    menuTabs: ["filterMenuTab", "generalMenuTab", "columnsMenuTab"],

   }), []);



  const refreshReportClicked = () => {
    dispatch(bulkTagConfigStatusStart({ "project_id": ctrl.data.project_id, "package_id": ctrl.pkg.package_id, "revision": +ctrl.pkg.active_revision }))
  }

  const closeViewStatus = () => {

    setIsBlkStatusOpen(prev => !prev);
    props.configBlkStatusShow()
  }

  const cancelBulkConfg = () => {
    const selectedRows = gridApi.getSelectedRows();
    console.log(selectedRows)
    dispatch(bulkTagConfigCancelStart(selectedRows))
  }

  const cancelBulkConfgHandler = () => {
    setOpenCnfrmDialog(true);
  }

  const onClickCell = (e) => {
    console.log(e.colDef.field);
  }

  const handleDialogClose = () => {
    setOpenCnfrmDialog(false);
  };

  const onSelectionChanged = (event) => {
    const selectedRows = gridApi.getSelectedRows();

    // let getSortedRow = getAgGridIndexofSelectedRows(event.api.getSelectedNodes());
    (selectedRows.length > 0) ? setIsCnclCnfgEnable(true) : setIsCnclCnfgEnable(false)
    // setSelectedDeletedData(getSortedRow);
    // props.selectedDeletedData(getSortedRow);
  };


  const clearFilters = () => {
    if (gridApi) {
      gridApi.setFilterModel(null);
    }
  };
  return (
    <>

      <ConfirmDialog
        open={openCnfrmDialog}
        handleClose={handleDialogClose}
        okBtnLbl="Yes"
        cnclBtnLbl="Cancel"
        dlgTitle="Cancel Bulk Configuration"
        dlgContent="Do you want to Cancel the Bulk configuration request? You may resubmit the Tag for Bulk configuration/ cNext configuration in future"
        //dlgContent="Cancelled tags will not be configured again! Do you want to proceed?"
        submitFunction={cancelBulkConfg} />

      <Dialog open={props.openBulkConfigStatus} onClose={closeViewStatus} className="viewReportStatus-model muiForm-Modal"
        aria-labelledby="draggable-dialog-title">
        <DialogTitle className="model-title mb-0 text-align-center" >
          <div className='header-row' >


            <div id="draggable-dialog-title" className=''>  Tags Configuration Status
              <StyledTooltip title='Refresh' placement="bottom" disableInteractive>
                <span className={blkTloader ? 'refresh-report disabled' : 'refresh-report'} onClick={refreshReportClicked}>
                  <LuRefreshCcw className={blkTloader ? 'animatonSVG' : ''} />
                </span>
              </StyledTooltip>
            </div>
            <div>
              {/* clear filter */}
              <StyledTooltip title={"Clear Filters"} placement="bottom" disableInteractive style={{ padding: '3px 0px' }}>
                <label>
                  <LuFilterX
                    className="tag-grid-head-cntrl mx-2"
                    onClick={clearFilters}
                    style={{ cursor: "pointer" }}
                  />
                </label>
              </StyledTooltip>

              <StyledTooltip title='Cancel Configuration' placement="bottom" disableInteractive>
                <IconButton aria-label="delete" disabled={!isCnclCnfgEnable} style={{ float: "right", color: isCnclCnfgEnable && "#ff3333" }} onClick={cancelBulkConfgHandler}>
                  <TbSettingsCancel />
                </IconButton>
              </StyledTooltip>
            </div>
          </div>

        </DialogTitle>
        <DialogContent>
          <Grid container className="ag-theme-alpine marginRow muiForm mb-2 pt-3" spacing={1.4}>
            <Grid item md={12} xs={12}>
              {blkTloader &&
                <div sm={12} md={12} lg={12}>
                  <LinearProgress /></div>}
              <div style={{ height: "65vh" }}>
                <AgGridReact
                  statusBar={statusBar}
                  defaultColDef={defaultColDef}
                  tooltipShowDelay={0}
                  rowData={bulkUpdatedTagsWithParentTagNumber.filter((tag) =>
                    !isInstrumentationTab
                      ? tag.technology_name === wsTabValue
                      : !commercialTypes.includes(tag.technology_name)
                  )}
                  onGridReady={onGridReady}
                  columnDefs={colDefs}
                  headerHeight={30}
                  rowSelection={"multiple"}
                  onSelectionChanged={onSelectionChanged}
                  overlayLoadingTemplate={'<div class="loadingx" style="margin: 7em"></div> <span class="ag-overlay-loading-center " style="font-size: 18px; z-index: 100000"> Loading Rows ...</span>'}
                  //  rowSelection={'single'}
                  isRowSelectable={isRowSelectableTagGrid}
                  rowHeight={26}
                  onCellClicked={(e) => onClickCell(e)}
                ></AgGridReact>

              </div>
            </Grid>


          </Grid>
        </DialogContent>
        <DialogActions className="model-actions" style={{ "paddingRight": "24px" }}>
          <button className="cnbtn btn cancel-btn" variant="outlined" onClick={closeViewStatus}>
            Close
          </button>


        </DialogActions>
      </Dialog>

    </>
  );
}
export default BulkConfig